import { axiosPrivate } from "api/axios";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";

const PartnerPlanService = {};

const getHeaders = () => ({
  Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
  "Content-Type": "application/json",
});

PartnerPlanService.getPlans = function ({ visibility, title } = {}) {
  return axiosPrivate({
    method: "get",
    url: "/partner-plans",
    params: {
      visibility: visibility || undefined,
      title: title || undefined,
    },
    headers: getHeaders(),
  });
};

PartnerPlanService.getPlan = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/partner-plans/${id}`,
    headers: getHeaders(),
  });
};

PartnerPlanService.createPlan = function (data) {
  return axiosPrivate({
    method: "post",
    url: "/partner-plans",
    data,
    headers: getHeaders(),
  });
};

PartnerPlanService.updatePlan = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/partner-plans/${id}`,
    data,
    headers: getHeaders(),
  });
};

PartnerPlanService.deletePlan = function (id) {
  return axiosPrivate({
    method: "delete",
    url: `/partner-plans/${id}`,
    headers: getHeaders(),
  });
};

export default PartnerPlanService;
